import { render } from "./map-215.vue?vue&type=template&id=45cdc290"
import script from "./map-215.vue?vue&type=script&lang=js"
export * from "./map-215.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__